export default __webpack_public_path__ + "static/media/logo-black.57f5f484.svg";